<script>
  import { onMount } from 'svelte';
  import { createGrid, ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
  import 'ag-grid-community/styles/ag-theme-alpine.css';
  import 'ag-grid-community/styles/ag-theme-quartz.css';
  import 'ag-grid-community/styles/ag-theme-balham.css';
  import 'ag-grid-community/styles/ag-theme-material.css';

  // ĐÚNG: dùng AllCommunityModule (số ít)
  ModuleRegistry.registerModules([AllCommunityModule]);

  let gridDiv;
  let gridApi;

  let currentTheme = 'ag-theme-alpine';

  const themes = [
    { name: 'Alpine', class: 'ag-theme-alpine' },
    { name: 'Quartz', class: 'ag-theme-quartz' },
    { name: 'Balham', class: 'ag-theme-balham' },
    { name: 'Material', class: 'ag-theme-material' }
  ];

  let columnDefs = [
    { field: 'athlete', headerName: 'VĐV', sortable: true, filter: true, flex: 2 },
    { field: 'age', headerName: 'Tuổi', width: 100 },
    { field: 'country', headerName: 'Quốc gia', sortable: true, filter: true, flex: 2 },
    { field: 'year', headerName: 'Năm', width: 100 },
    { field: 'date', headerName: 'Ngày', width: 130 },
    { field: 'sport', headerName: 'Môn thi', sortable: true, filter: true, flex: 2 },
    { field: 'gold', headerName: 'Vàng', width: 100, cellStyle: { color: '#d4a017' } },
    { field: 'silver', headerName: 'Bạc', width: 100, cellStyle: { color: '#a8a8a8' } },
    { field: 'bronze', headerName: 'Đồng', width: 100, cellStyle: { color: '#cd7f32' } },
    { field: 'total', headerName: 'Tổng', width: 110, cellStyle: { fontWeight: 'bold' } }
  ];

  let rowData = [];

  onMount(async () => {
    try {
      const res = await fetch('https://www.ag-grid.com/example-assets/olympic-winners.json');
      if (!res.ok) throw new Error('Không tải được dữ liệu');
      rowData = await res.json();
      console.log(`Đã tải ${rowData.length} dòng dữ liệu thành công!`);

      const gridOptions = {
        columnDefs,
        rowData,
        pagination: true,
        paginationPageSize: 20,
        paginationPageSizeSelector: [10, 20, 50, 100],
        animateRows: true,
        defaultColDef: {
          flex: 1,
          minWidth: 100,
          resizable: true,
          sortable: true,
          filter: true
        },
        overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Đang tải dữ liệu...</span>',
        overlayNoRowsTemplate: '<span class="ag-overlay-loading-center">Không có dữ liệu</span>',

        onGridReady: (params) => {
          gridApi = params.api;
        },

        onFirstDataRendered: () => {
          if (gridDiv && gridDiv.offsetWidth > 0) {
            gridApi.sizeColumnsToFit();
          }
        },

        onGridSizeChanged: () => {
          if (gridDiv && gridDiv.offsetWidth > 0) {
            gridApi.sizeColumnsToFit();
          }
        }
      };

      createGrid(gridDiv, gridOptions);
    } catch (err) {
      console.error('Lỗi khi tải dữ liệu:', err);
      rowData = [{ athlete: 'Lỗi', country: 'Kiểm tra mạng' }];
    }
  });

  function changeTheme(themeClass) {
    if (!gridDiv) return;

    themes.forEach((t) => gridDiv.classList.remove(t.class));
    gridDiv.classList.add(themeClass);
    currentTheme = themeClass;

    if (gridApi && gridDiv.offsetWidth > 0) {
      setTimeout(() => gridApi.sizeColumnsToFit(), 0);
    }
  }

  function refreshGrid() {
    if (gridApi) {
      gridApi.refreshCells({ force: true });
    }
  }
</script>

<!-- Toolbar -->
<div class="toolbar">
  <div class="toolbar-group">
    <span class="label">Theme:</span>
    <select bind:value={currentTheme} on:change={(e) => changeTheme(e.target.value)}>
      {#each themes as theme}
        <option value={theme.class}>{theme.name}</option>
      {/each}
    </select>
  </div>

  <div class="toolbar-group">
    <button on:click={refreshGrid} class="refresh-btn">Làm mới Grid</button>
  </div>
</div>

<!-- Grid Container -->
<div class="grid-wrapper">
  <div class="ag-theme-alpine" style="height: 100%; width: 100%;" bind:this={gridDiv}></div>
</div>

<style>
  :global(body) {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .toolbar {
    padding: 12px 16px;
    background: #f5f7fa;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    align-items: center;
    font-size: 14px;
  }

  .toolbar-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .label {
    font-weight: 600;
    color: #333;
  }

  select,
  button {
    padding: 6px 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    background: white;
    font-size: 14px;
    cursor: pointer;
  }

  select:focus,
  button:focus {
    outline: 2px solid #0066cc;
    outline-offset: 2px;
  }

  .refresh-btn {
    background: #28a745;
    color: white;
    font-weight: 500;
  }

  .refresh-btn:hover {
    background: #218838;
  }

  button:hover {
    background: #f0f0f0;
  }

  .grid-wrapper {
    height: calc(100vh - 80px);
    width: 100%;
    min-height: 600px;
  }

  @media (max-width: 768px) {
    .toolbar {
      flex-direction: column;
      align-items: stretch;
    }
    .toolbar-group {
      justify-content: center;
    }
    .grid-wrapper {
      height: 70vh;
    }
  }
</style>
